
export const handleTooltipPosition = ({mousePos, tooltipDims, viewport, mouseOffset={x:0,y:0}}) => {
  /* Generates new position for tooltip if tooltip would appear outside of viewport.
  Returns an object with x and y coordinates.

  mousePos: object. X and Y position of cursor.
  tooltipDims: object. width and height of tooltip.
  viewport: object. width and height of current viewport.
  mouseOffset: object. Optional. Amount of pixels to add to x and y to move tooltip away from cursor.

  EXAMPLE:
  If tooltip's is within viewport, then tooltip is positioned below and to the
  right of mouse by default. Eg.

                +>+---------------+
                  | TOOLTIP       |
                  | DATA: blah    |
                  +---------------+

  If tooltip would be outside of viewport's width, then tooltip is moved to the left of the mouse
  
                  +---------------+<+
                  | TOOLTIP       |
                  | DATA: blah    |
                  +---------------+
  
  If tooltip would be outside of viewport's height, then tooltip is moved above

                  +---------------+
                  | TOOLTIP       |
                  | DATA: blah    |
                +>+---------------+
  */

  // VARS
  let x = mousePos.x
  let y = mousePos.y
  const topRightCornerTooltipPos = x + mouseOffset.x + tooltipDims.width
  const bottomLeftCornerTooltipPos = y + mouseOffset.y + tooltipDims.height

  // Handle X position
  // If tooltip's far right corner is greater than screen width, 
  // move tooltip's position left
  if (topRightCornerTooltipPos > viewport.width) {
    x = mousePos.x - tooltipDims.width - mouseOffset.x
  } else {
    x = mousePos.x + mouseOffset.x
  }

  // Handle Y position
  // If tooltip's bottom left corner is greater than screen height, 
  // move tooltip's position up
  if (bottomLeftCornerTooltipPos > viewport.height) {
    y = mousePos.y - tooltipDims.height
  } else {
    y = mousePos.y + mouseOffset.y
  }

  return {
    x,
    y
  }
}


